import React from "react";

const Category = ({categories, filterItems}) => {
    return (
        <div className="btn-container">
        {
            categories.map((category, index) => {
                return (
                    <button type="button" className="filter-btn" key={index} onClick={() => filterItems(category)}>
                        {category}
                    </button>
                );
            })
        }
        </div>
    );
}

export default Category;